/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Injectable } from '@angular/core';
import * as Yang from 'yang-js';

@Injectable({ providedIn: 'root' })
export class YangService {
  //eslint-disable-next-line
  constructor() {}
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public validateYangModel(yang_scema: any, yang_model: any): any {
    try {
      const schema = Yang.parse(yang_scema);
      const model = schema.eval(yang_model).toJSON();
      return model;
    } catch (err) {
      return err.message.includes(']') ? err.message.split(']')[1] : err.message;
    }
  }
}
